export const MEMBERSHIP_PURCHASE_PAUSED_ERROR = 'membership_purchase_paused';

export const MEMBERSHIP_PURCHASE_COMING_SOON_SNACKBAR = 'Demnächst verfügbar';

export const PROFILE_MEMBERSHIP_MENU_SUBTITLE = 'Mehr Besucher erreichen';

export const PARTNER_FREEMIUM_LEAD =
  'Kundengewinnung und Kundenpflege mit Basisfunktionen';

export const PARTNER_FREEMIUM_LIMITATIONS = [
  'Basis-Sichtbarkeit für dein Lokal',
  'Mindestens 1 Freemium- und 1 Premium-Deal für Highlights',
];

export const PARTNER_FREEMIUM_COMMUNITY_TEXT =
  'Mit dem Partner-Paket erreichst du mehr Besucher, Bonus-Punkte und erweiterte Premium-Funktionen.';

export const PARTNER_SUBSCRIPTION_SECTION_LABEL = 'Beliebt unter aktiven Gastronomen';

export const PARTNER_SUBSCRIPTION_TITLE = 'Premium Abo';

export const PARTNER_SUBSCRIPTION_SUBTITLE = 'Schalte alle Premium Funktionen frei & mehr';

export const PARTNER_SUBSCRIPTION_PITCH =
  'Erreiche deine Zielgruppe, automatisiere Anzeigen & erhalte Kundenprognosen';

export const PARTNER_SUBSCRIPTION_COMMUNITY =
  'Premium Partner werden von Kunden mehr gesehen & haben mehr Funktionen.';

export const PARTNER_SUBSCRIPTION_BENEFITS = [
  'Erhalte mtl. 10 Punkte Werbemittel für Highlights',
  'Personalisiere Deals Entfernung, Geschlecht, Alter',
  'Erhalte Prognosen zum Kundenverhalten',
  'Partner-Siegel (WeLoveOllaa)',
];

export const PARTNER_ACTIVE_TITLE = 'Partner-Paket';

export const PARTNER_ACTIVE_SUBTITLE = '3 Monate Premium · mehr Sichtbarkeit & Highlights';

export const PARTNER_DEBUG_ACTIVE_TITLE = 'Partner-Paket (Test)';

export const PARTNER_DEBUG_ACTIVE_SUBTITLE = 'Test-Zugang – kein Stripe-Abo';

export const PARTNER_DEBUG_HIGHLIGHT_SUFFIX = ' (Test)';

export const getPartnerActiveBenefits = (monthlyEur = 69, intervalMonths = 3) => [
  `${intervalMonths} Monate Partner-Premium (${Number(monthlyEur).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €/Monat)`,
  'Highlights für mehr Sichtbarkeit buchen',
  'Werbebudget für Highlights nutzen',
  'Bonus-Punkte bei Tour-Teilnahme',
];

export const COCKPIT_HIGHLIGHTS_TITLE = 'Deals bewerben';

export const DEALS_HIGHLIGHTS_TITLE = 'Deal bewerben';

export const MEMBERSHIP_HIGHLIGHTS_TITLE = 'Deals bewerben';

export const HIGHLIGHT_OFFER_SUBTITLE = 'Deal bei Mitgliedern ganz oben sichtbar';

export const HIGHLIGHT_VORTEILE_CTA = 'Vorteile ansehen';

export const HIGHLIGHT_BENEFITS_TITLE = 'Vorteile Deal bewerben';

export const DEAL_PUBLISH_INFO =
  'Lege fest, ab wann dein Deal für Mitglieder sichtbar ist. Ohne Planung wird er beim Veröffentlichen sofort freigeschaltet.';

export const DEAL_HIGHLIGHT_INFO =
  'Bewirb genau diesen Deal. Dein Spot wird in Karte und Listen hervorgehoben, solange das Highlight läuft.';

export const DEAL_HIGHLIGHT_SCHEDULE_INFO =
  'Standardmäßig startet das Highlight mit der Deal-Veröffentlichung. Mit der Zeitplanung kannst du einen späteren Start wählen.';

export const DEAL_PROMOTE_DISCARD_TITLE = 'Deal bewerben verwerfen?';

export const DEAL_PROMOTE_DISCARD_MESSAGE =
  'Wenn Du jetzt gehst, gehen deine bisherigen Angaben verloren';

export const DEAL_PROMOTE_SELECT_SNACKBAR = 'Wähle einen Deal aus der Liste oder lege einen neuen an.';

export const HIGHLIGHT_BENEFIT_1_TITLE = '1. 🔥 Deal + Spot wird ganz oben sichtbar';

export const HIGHLIGHT_BENEFIT_1_SUB = 'Nur der gewählte Deal wird hervorgehoben';

export const HIGHLIGHT_BENEFITS_ORDER_LABEL = 'Bestellen';

export const HIGHLIGHT_BENEFITS_BACK_LABEL = 'zurück';

export const HIGHLIGHT_DISPLAY_TITLES = {
  highlight_60m: '60 Minuten',
  highlight_1d: '1 Day',
  highlight_7d: '7 Days',
};

export const HIGHLIGHT_MODAL_DURATION_LABELS = {
  highlight_60m: '60 Min.',
  highlight_1d: '1 Tag',
  highlight_7d: '7 Tage',
};

const HIGHLIGHT_TOOLTIP_LABELS = {
  highlight_60m: 'Deal bewerben 60Min',
  highlight_1d: '1 Tag',
  highlight_7d: '7 Tage',
};

const FALLBACK_HIGHLIGHT_PURCHASE_BONUS = {
  highlight_60m: 2,
  highlight_1d: 4,
  highlight_7d: 6,
};

export const HIGHLIGHT_PURCHASE_INTRO =
  'Du kannst Punkte einlösen oder Deal bewerben direkt bestellen.';

export const HIGHLIGHT_POINTS_BALANCE_LABEL = 'Meine Punkte';

export const PARTNER_POINTS_TOOLTIP_HEADER = 'Mit Punkten* Deal bewerben freischalten';

export const PARTNER_POINTS_TOOLTIP_EARN_SECTION = 'So erhältst Du Punkte';

export const PARTNER_POINTS_TOOLTIP_PURCHASE_SECTION = 'Kauf von';

export const PARTNER_POINTS_TOOLTIP_FOOTNOTE =
  '*Nicht übertragbar. Stichtag 31.01., Verlängerung bis 31.03.';

export const getHighlightDisplayTitle = (productKey) => (
  HIGHLIGHT_DISPLAY_TITLES[productKey] || productKey
);

export const getHighlightModalTitle = (productKey) => {
  const duration = HIGHLIGHT_MODAL_DURATION_LABELS[productKey]
    || getHighlightDisplayTitle(productKey);
  return `Deal bewerben ${duration}`;
};

/** Mockup-style point decimals use "." (e.g. 9.9, 0.5P). */
export const formatPointsDecimalMockup = (value) => {
  const num = Number(value) || 0;
  if (Number.isInteger(num)) return String(num);
  const rounded = Math.round(num * 100) / 100;
  return String(rounded);
};

/** Always at least 3 characters, zero-padded integers (003, 010). */
export const formatPointsBalanceMockup = (value) => {
  const num = Number(value) || 0;
  const formatted = Number.isInteger(num)
    ? String(num)
    : formatPointsDecimalMockup(num);
  return formatted.padStart(3, '0');
};

export const formatPointsBalancePadded = formatPointsBalanceMockup;

export const formatPointsShort = formatPointsDecimalMockup;

export const formatHighlightPointsRedeemLabel = (pointsCost) => (
  `${formatPointsDecimalMockup(pointsCost)} Punkte einlösen`
);

export const formatHighlightPointsCollectLabel = (pointsNeeded) => (
  `noch ${formatPointsDecimalMockup(pointsNeeded)} Punkte sammeln`
);

export const formatHighlightPriceButtonLabel = (priceEur) => {
  const priceLabel = Number(priceEur).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${priceLabel}€ Deal bewerben`;
};

export const formatPartnerPointsHighlight = (points) => `${formatPointsDecimalMockup(points)}P`;

export const buildPartnerPointsTooltipLines = ({
  invitationAmount,
  subscriptionMonthlyAmount,
  highlights = [],
} = {}) => {
  const highlightByKey = Object.fromEntries((highlights || []).map((item) => [item.key, item]));
  const resolvePurchaseBonus = (key) => {
    const raw = highlightByKey[key]?.purchaseBonusPoints;
    if (raw == null || raw === '') {
      return FALLBACK_HIGHLIGHT_PURCHASE_BONUS[key] ?? 0;
    }
    const amount = Number(raw);
    return Number.isFinite(amount) ? amount : (FALLBACK_HIGHLIGHT_PURCHASE_BONUS[key] ?? 0);
  };
  const highlightLine = Object.keys(HIGHLIGHT_TOOLTIP_LABELS)
    .map((key) => {
      const amount = resolvePurchaseBonus(key);
      if (!(amount > 0)) return null;
      return `${HIGHLIGHT_TOOLTIP_LABELS[key]} ${formatPartnerPointsHighlight(amount)}`;
    })
    .filter(Boolean)
    .join(', ');

  const earnItems = [];
  if (Number(invitationAmount) > 0) {
    earnItems.push(`Gäste, Freunde einladen ${formatPartnerPointsHighlight(invitationAmount)}`);
  }

  const purchaseItems = [];
  if (highlightLine) purchaseItems.push(highlightLine);
  if (Number(subscriptionMonthlyAmount) > 0) {
    purchaseItems.push(
      `Premium Abo ${formatPartnerPointsHighlight(subscriptionMonthlyAmount)} pro Monat`,
    );
  }

  return { earnItems, purchaseItems };
};

export const HIGHLIGHT_FOOTNOTES = {
  highlight_60m: 'Gilt am jew. Tag bis 05:00Uhr nächsten Tag.',
  highlight_1d: 'Tag endet um 05:00Uhr morgens',
  highlight_7d: null,
};

export const getHighlightFootnote = (productKey, priceEur, pointsCost = null) => {
  const parts = [];
  if (productKey === 'highlight_7d' && priceEur != null) {
    const formatted = Number(priceEur).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    parts.push(`Abbuchung 1x Gesamt ${formatted},-€`);
  } else {
    const base = HIGHLIGHT_FOOTNOTES[productKey];
    if (base) parts.push(base);
  }
  if (pointsCost != null && Number(pointsCost) > 0) {
    parts.push(`oder ${Number(pointsCost)} P Werbebudget`);
  }
  return parts.join(' · ');
};

export const getHighlightPointsCheckboxLabel = (pointsCost) => {
  const cost = Number(pointsCost).toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `Mit ${cost} P Werbebudget bezahlen`;
};

export const getHighlightPurchaseMessage = ({
  dealName,
  productTitle,
  priceEur,
  pointsCost,
  availablePoints,
  canPayWithPoints,
}) => {
  const priceLabel = Number(priceEur).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const dealLabel = dealName ? `„${dealName}"` : 'deinen Deal';
  const durationLabel = productTitle || 'Highlight';

  if (canPayWithPoints) {
    return `${dealLabel} für ${durationLabel} bewerben (${priceLabel} € oder ${pointsCost} P Werbebudget).`;
  }

  const available = Number(availablePoints || 0).toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  if (pointsCost > 0) {
    return `${dealLabel} für ${durationLabel} bewerben (${priceLabel} €). Verfügbar: ${available} P Werbebudget (benötigt ${pointsCost} P).`;
  }
  return `${dealLabel} für ${durationLabel} bewerben (${priceLabel} €).`;
};

export const PARTNER_SUBSCRIPTION_CTA_LABEL = 'Abo aktivieren';

export const PARTNER_SUBSCRIPTION_CANCEL_TITLE = 'Abo kündigen?';

export const getPartnerSubscriptionCancelMessage = (contractPhase) => {
  if (contractPhase === 'minimum') {
    return 'Dein Partner-Paket läuft bis zum Ende der Mindestlaufzeit weiter. Danach endet es – keine neue Mindestlaufzeit.';
  }
  return 'Das Abo läuft bis zum nächsten Monatsende weiter und wird danach nicht verlängert.';
};

export const getPartnerSubscriptionFootnote = (monthlyEur) => {
  const monthly = Number(monthlyEur);
  const yearlyTotal = Math.round(monthly * 12);
  const formatted = yearlyTotal.toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return `Mtl. abbuchbar, kündbar. Gesamt 12 Monate ${formatted}€`;
};

export const getPartnerActiveSubscriptionFootnote = (monthlyEur, intervalMonths = 3, contractPhase = 'minimum') => {
  const monthly = Number(monthlyEur).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (contractPhase === 'indefinite') {
    return `Abbuchung monatlich (${monthly} €/Monat). Monatlich kündbar (max. 1 Monat Frist).`;
  }
  return `${monthly} €/Monat · Mindestlaufzeit ${intervalMonths} Monate · danach monatlich kündbar (max. 1 Monat Frist).`;
};

export const HIGHLIGHT_PREMIUM_REQUIRED_TITLE = 'Partner-Paket';

export const HIGHLIGHT_PREMIUM_REQUIRED_MESSAGE =
  'Mit dem Partner-Paket erreichst du mehr Besucher und erweiterte Premium-Funktionen.';

export const HIGHLIGHT_PREMIUM_REQUIRED_ACTION = 'Partner-Paket holen';

export const HIGHLIGHT_DEAL_MIX_TITLE = 'Voraussetzungen fehlen';

export const HIGHLIGHT_ACTIVE_INFO_TITLE = 'Highlight aktiv';

export const getHighlightActiveInfoMessage = (remainingLabel, endsAtLabel) => {
  if (endsAtLabel) {
    return `Dein Highlight ist ${remainingLabel} aktiv (bis ${endsAtLabel}). Danach kannst du ein neues Highlight buchen.`;
  }
  return `Dein Highlight ist ${remainingLabel} aktiv. Danach kannst du ein neues Highlight buchen.`;
};

export const PROFILE_HIGHLIGHT_ACTIVE_LABEL = 'Highlight aktiv';

export const PARTNER_HIGHLIGHT_INACTIVE_TITLE = 'Kein Highlight aktiv';

export const PARTNER_HIGHLIGHT_INACTIVE_HINT =
  'Buche ein Highlight, um dein Lokal in der App stärker hervorzuheben.';

export const PARTNER_HIGHLIGHT_PENDING_TITLE = 'Highlight wird aktiviert…';

export const PARTNER_HIGHLIGHT_PENDING_HINT =
  'Die Zahlung war erfolgreich. Gleich ist dein Highlight live.';
